export const botIcon = () => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="32" height="32" rx="16" fill="#0057B7" />
    <path
      d="M25.4992 14.936V11.961C25.4992 11.4305 25.2885 10.9218 24.9134 10.5468C24.5383 10.1717 24.0296 9.96098 23.4992 9.96098H17.4992V8.64898C17.8042 8.37498 17.9992 7.98098 17.9992 7.53898C17.9992 7.14116 17.8411 6.75962 17.5598 6.47832C17.2785 6.19702 16.897 6.03898 16.4992 6.03898C16.1013 6.03898 15.7198 6.19702 15.4385 6.47832C15.1572 6.75962 14.9992 7.14116 14.9992 7.53898C14.9992 7.98098 15.1942 8.37498 15.4992 8.64898V9.96098H9.49916C8.96873 9.96098 8.46002 10.1717 8.08495 10.5468C7.70988 10.9218 7.49916 11.4305 7.49916 11.961V14.959L7.42716 14.964C7.17514 14.9822 6.93934 15.0951 6.76718 15.2801C6.59502 15.465 6.49927 15.7083 6.49916 15.961V17.961C6.49916 18.2262 6.60452 18.4805 6.79206 18.6681C6.97959 18.8556 7.23395 18.961 7.49916 18.961V23.961C7.49916 24.4914 7.70988 25.0001 8.08495 25.3752C8.46002 25.7503 8.96873 25.961 9.49916 25.961H23.4992C24.0296 25.961 24.5383 25.7503 24.9134 25.3752C25.2885 25.0001 25.4992 24.4914 25.4992 23.961V18.961C25.7644 18.961 26.0187 18.8556 26.2063 18.6681C26.3938 18.4805 26.4992 18.2262 26.4992 17.961V16.023C26.5109 15.8678 26.4862 15.712 26.4272 15.568C26.2252 15.08 25.7922 14.963 25.4992 14.936ZM11.4992 15.961C11.4992 14.857 12.1712 13.961 12.9992 13.961C13.8272 13.961 14.4992 14.857 14.4992 15.961C14.4992 17.065 13.8272 17.961 12.9992 17.961C12.1712 17.961 11.4992 17.065 11.4992 15.961ZM20.4972 21.961C19.4962 21.958 12.4992 21.961 12.4992 21.961V19.961C12.4992 19.961 19.5002 19.959 20.5012 19.961L20.4972 21.961ZM19.9992 17.961C19.1712 17.961 18.4992 17.065 18.4992 15.961C18.4992 14.857 19.1712 13.961 19.9992 13.961C20.8272 13.961 21.4992 14.857 21.4992 15.961C21.4992 17.065 20.8272 17.961 19.9992 17.961Z"
      fill="white"
    />
  </svg>
);

export const userIcon = () => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      width="32"
      height="32"
      rx="16"
      fill="#0057B7"
      fillOpacity="0.18"
    />
    <path
      d="M16.5156 17.25C19.6223 17.25 22.1406 14.7316 22.1406 11.625C22.1406 8.51836 19.6223 6 16.5156 6C13.4094 6 10.8906 8.51836 10.8906 11.625C10.8906 14.7316 13.4102 17.25 16.5156 17.25ZM16.5156 7.25C18.9281 7.25 20.8906 9.2125 20.8906 11.625C20.8906 14.0391 18.9297 16 16.5156 16C14.1016 16 12.1406 14.0391 12.1406 11.625C12.1406 9.2125 14.1016 7.25 16.5156 7.25ZM20.2305 18.5H12.7656C9.31406 18.5 6.51562 21.298 6.51562 24.75C6.51562 25.4402 7.07539 26 7.73047 26H25.2656C25.9559 26 26.4805 25.4402 26.4805 24.75C26.5156 21.2969 23.7188 18.5 20.2305 18.5ZM7.76562 24.75C7.76562 21.993 10.0086 19.75 12.7656 19.75H20.2305C23.0234 19.75 25.2656 21.9922 25.2656 24.75H7.76562Z"
      fill="#0057B7"
    />
    <path
      d="M7.76562 24.75C7.76562 21.993 10.0086 19.75 12.7656 19.75H20.2305C23.0234 19.75 25.2656 21.9922 25.2656 24.75H7.76562Z"
      fill="#0057B7"
    />
    <path
      d="M16.5156 7.25C18.9281 7.25 20.8906 9.2125 20.8906 11.625C20.8906 14.0391 18.9297 16 16.5156 16C14.1016 16 12.1406 14.0391 12.1406 11.625C12.1406 9.2125 14.1016 7.25 16.5156 7.25Z"
      fill="#0057B7"
    />
  </svg>
);

export const closeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.584 3.08325C14.9061 2.76109 14.9062 2.23875 14.584 1.91659C14.2618 1.59442 13.7395 1.59442 13.4173 1.91659L8.50065 6.83325L3.58399 1.91659C3.26182 1.59442 2.73948 1.59442 2.41732 1.91659C2.09515 2.23875 2.09515 2.76109 2.41732 3.08325L7.33398 7.99992L2.41732 12.9166C2.09515 13.2388 2.09515 13.7611 2.41732 14.0833C2.73948 14.4054 3.26182 14.4054 3.58398 14.0833L8.50065 9.16659L13.4173 14.0833C13.7395 14.4054 14.2618 14.4054 14.584 14.0833C14.9062 13.7611 14.9062 13.2388 14.584 12.9166L9.66732 7.99992L14.584 3.08325Z"
      fill="#222222"
    />
  </svg>
);

export const pencilIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_33703_18177)">
      <path d="M7.33301 2.66666H4.53301C3.4129 2.66666 2.85285 2.66666 2.42503 2.88464C2.0487 3.07639 1.74274 3.38235 1.55099 3.75867C1.33301 4.1865 1.33301 4.74655 1.33301 5.86666V11.4667C1.33301 12.5868 1.33301 13.1468 1.55099 13.5746C1.74274 13.951 2.0487 14.2569 2.42503 14.4487C2.85285 14.6667 3.4129 14.6667 4.53301 14.6667H10.133C11.2531 14.6667 11.8132 14.6667 12.241 14.4487C12.6173 14.2569 12.9233 13.951 13.115 13.5746C13.333 13.1468 13.333 12.5868 13.333 11.4667V8.66666M5.33299 10.6667H6.44935C6.77547 10.6667 6.93853 10.6667 7.09198 10.6298C7.22803 10.5972 7.35809 10.5433 7.47739 10.4702C7.61194 10.3877 7.72724 10.2724 7.95785 10.0418L14.333 3.66666C14.8853 3.11437 14.8853 2.21894 14.333 1.66666C13.7807 1.11437 12.8853 1.11437 12.333 1.66665L5.95783 8.04182C5.72723 8.27242 5.61193 8.38772 5.52947 8.52228C5.45637 8.64157 5.40249 8.77163 5.36983 8.90768C5.33299 9.06113 5.33299 9.22419 5.33299 9.55031V10.6667Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_33703_18177">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export const chevronUpIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M4.6665 10L7.99984 13.3334L11.3332 10M4.6665 6.00002L7.99984 2.66669L11.3332 6.00002"
      stroke="#0057B7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const hidLogoIcon = () => (
  <svg
    width="58"
    height="24"
    viewBox="0 0 58 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M55.3164 2.28562e-08H2.68358C1.97185 2.28562e-08 1.28927 0.284226 0.786003 0.790152C0.282734 1.29608 0 1.98226 0 2.69775V21.3458C0.0113596 22.0537 0.2991 22.7287 0.801144 23.2253C1.30319 23.7218 1.97929 24.0001 2.68358 24H55.3164C55.6688 24 56.0178 23.9302 56.3434 23.7946C56.669 23.6591 56.9648 23.4604 57.214 23.2098C57.4632 22.9593 57.6609 22.6619 57.7957 22.3346C57.9306 22.0073 58 21.6565 58 21.3023V2.65423C57.9886 1.94632 57.7009 1.27126 57.1989 0.774706C56.6968 0.278153 56.0207 -9.20761e-05 55.3164 2.28562e-08ZM22.4147 18.1756H16.2313V12.9231H12.0885V18.1818H5.90512V5.84305H12.0885V11.1018H16.2313V5.84305H22.4147V18.1756ZM31.8876 18.1756H25.7043V5.84305H31.8876V18.1756ZM45.1571 18.2191H35.0721V5.84305H45.1571C48.694 5.84305 51.897 8.54079 51.8908 12.0591C51.8846 15.5773 48.694 18.2191 45.1571 18.2191ZM41.175 6.95571V17.0692C43.7164 17.0692 45.1757 17.4856 45.1757 12.0218C45.1757 6.55789 43.4382 6.95571 41.175 6.95571Z"
      fill="white"
    />
    <path
      d="M22.4147 18.1756H16.2313V12.9231H12.0885V18.1818H5.90512V5.84305H12.0885V11.1018H16.2313V5.84305H22.4147V18.1756Z"
      fill="#003087"
    />
    <path
      d="M31.8876 18.1756H25.7043V5.84305H31.8876V18.1756Z"
      fill="#003087"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.1571 18.2191H35.0721V5.84305H45.1571C48.694 5.84305 51.897 8.54079 51.8908 12.0591C51.8846 15.5773 48.694 18.2191 45.1571 18.2191ZM41.175 17.0692V6.95571C43.4382 6.95571 45.1757 6.55789 45.1757 12.0218C45.1757 17.4856 43.7164 17.0692 41.175 17.0692Z"
      fill="#003087"
    />
  </svg>
);

export const editIconLarge = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 12.0002H14.8C13.1198 12.0002 12.2798 12.0002 11.638 12.3272C11.0735 12.6148 10.6146 13.0738 10.327 13.6383C10 14.28 10 15.1201 10 16.8002V25.2002C10 26.8804 10 27.7205 10.327 28.3622C10.6146 28.9267 11.0735 29.3856 11.638 29.6732C12.2798 30.0002 13.1198 30.0002 14.8 30.0002H23.2C24.8802 30.0002 25.7202 30.0002 26.362 29.6732C26.9265 29.3856 27.3854 28.9267 27.673 28.3622C28 27.7205 28 26.8804 28 25.2002V21.0002M16 24.0002H17.6745C18.1637 24.0002 18.4083 24.0002 18.6385 23.945C18.8425 23.896 19.0376 23.8152 19.2166 23.7055C19.4184 23.5818 19.5914 23.4089 19.9373 23.063L29.5 13.5002C30.3284 12.6718 30.3284 11.3287 29.5 10.5002C28.6716 9.6718 27.3284 9.6718 26.5 10.5002L16.9372 20.063C16.5913 20.4089 16.4184 20.5818 16.2947 20.7837C16.185 20.9626 16.1042 21.1577 16.0552 21.3618C16 21.5919 16 21.8365 16 22.3257V24.0002Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const documentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 7.076V7C19.0014 5.58355 18.5017 4.21226 17.5893 3.12885C16.6768 2.04544 15.4105 1.31977 14.0144 1.08029C12.6184 0.840804 11.1826 1.10295 9.96125 1.82033C8.73989 2.5377 7.81171 3.66405 7.341 5H12.5C13.0304 5 13.5391 5.21071 13.9142 5.58578C14.2893 5.96086 14.5 6.46956 14.5 7V8.022C15.5446 7.35284 16.7595 6.99808 18 7C18.34 7 18.6733 7.02533 19 7.076ZM13.5 23C12.4391 23 11.4217 22.5786 10.6716 21.8284C9.92143 21.0783 9.5 20.0609 9.5 19H12.5C13.0304 19 13.5391 18.7893 13.9142 18.4142C14.2893 18.0391 14.5 17.5304 14.5 17V15.126C15.4405 15.3717 16.2594 15.9514 16.8038 16.7567C17.3482 17.562 17.5809 18.5379 17.4584 19.5022C17.336 20.4665 16.8667 21.3533 16.1383 21.997C15.4099 22.6406 14.4721 22.9972 13.5 23ZM14.5 14.1C15.6257 14.3298 16.6379 14.9402 17.3664 15.8286C18.0949 16.717 18.4952 17.8291 18.5 18.978C19.3575 18.8997 20.1846 18.6211 20.9148 18.1648C21.645 17.7084 22.2578 17.087 22.704 16.3505C23.1501 15.614 23.4171 14.7831 23.4835 13.9246C23.5498 13.0661 23.4137 12.204 23.086 11.4077C22.7583 10.6114 22.2482 9.90322 21.5968 9.34008C20.9454 8.77694 20.1709 8.37461 19.3356 8.16548C18.5004 7.95634 17.6276 7.94625 16.7878 8.13601C15.9479 8.32576 15.1642 8.71007 14.5 9.258V14.1ZM1.5 17V7C1.5 6.73478 1.60536 6.48043 1.79289 6.29289C1.98043 6.10535 2.23478 6 2.5 6H12.5C12.7652 6 13.0196 6.10535 13.2071 6.29289C13.3946 6.48043 13.5 6.73478 13.5 7V17C13.5 17.2652 13.3946 17.5196 13.2071 17.7071C13.0196 17.8946 12.7652 18 12.5 18H2.5C2.23478 18 1.98043 17.8946 1.79289 17.7071C1.60536 17.5196 1.5 17.2652 1.5 17ZM7.219 8.53C8.089 8.421 9.075 8.598 9.706 8.779L9.294 10.221C8.759 10.068 7.994 9.945 7.406 10.019C7.113 10.056 6.943 10.132 6.859 10.201C6.807 10.244 6.75 10.308 6.75 10.5C6.75 10.57 6.768 10.666 6.989 10.826C7.231 11.003 7.58 11.156 8.037 11.344L8.107 11.374C8.506 11.538 8.994 11.74 9.379 12.006C9.805 12.3 10.25 12.773 10.25 13.5C10.25 14.185 10.01 14.756 9.509 15.126C9.054 15.463 8.494 15.55 8.019 15.562C7.53 15.574 7.016 15.508 6.569 15.436C6.375 15.4047 6.199 15.3747 6.041 15.346C5.83054 15.3068 5.61914 15.2728 5.407 15.244L5.593 13.756C5.814 13.783 6.089 13.831 6.361 13.879C6.514 13.906 6.666 13.932 6.807 13.955C7.234 14.024 7.637 14.071 7.981 14.063C8.339 14.053 8.529 13.985 8.616 13.921C8.657 13.891 8.75 13.815 8.75 13.5V13.498C8.75 13.472 8.751 13.395 8.527 13.241C8.279 13.069 7.927 12.922 7.463 12.731L7.453 12.726C7.036 12.553 6.515 12.338 6.105 12.039C5.669 11.721 5.25 11.229 5.25 10.499C5.25 9.892 5.484 9.389 5.907 9.042C6.297 8.722 6.783 8.586 7.219 8.531V8.53Z"
      fill="#3D3E3E"
    />
  </svg>
);

export const chevronDownIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M22.1982 8.58498L13.1587 16.7665C12.8107 17.0772 12.2889 17.0772 11.9406 16.7665L2.80054 8.58498C2.42783 8.19863 2.39772 7.67592 2.73293 7.30093C3.08974 6.9089 3.66472 6.91458 4.01868 7.23275L12.4996 14.8689L20.9823 7.23275C21.357 6.89884 21.9306 6.92816 22.2675 7.30025C22.6016 7.67592 22.5732 8.19863 22.1982 8.58498Z"
      fill="#1E1E1E"
    />
  </svg>
);

export const chevronUpIconLarge = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M2.8018 15.415L11.8413 7.2335C12.1893 6.9228 12.7111 6.9228 13.0594 7.2335L22.1995 15.415C22.5722 15.8014 22.6023 16.3241 22.2671 16.6991C21.9103 17.0911 21.3353 17.0854 20.9813 16.7672L12.5004 9.1311L4.0177 16.7672C3.643 17.1012 3.0694 17.0718 2.7325 16.6997C2.3984 16.3241 2.4268 15.8014 2.8018 15.415Z"
      fill="#1E1E1E"
    />
  </svg>
);

export const hidLogoLarge = () => (
  <svg
    width="90"
    height="37"
    viewBox="0 0 90 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_33426_2818)">
      <mask
        id="mask0_33426_2818"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="90"
        height="37"
      >
        <path d="M90 0H0V37H90V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_33426_2818)">
        <path
          d="M85.835 37C88.1311 37 90 35.1387 90 32.8399V4.15643C90 1.86502 88.1311 0 85.835 0H4.16133C1.86888 0 0 1.86502 0 4.15643V32.8399C0 35.1387 1.86517 37 4.16133 37H85.835Z"
          fill="white"
        />
      </g>
      <path
        d="M49.505 9.00635H39.9414V28.005H49.505V9.00635Z"
        fill="#003087"
      />
      <path
        d="M25.2393 19.9072V28.0013H34.8029V9.00635H25.2393V17.0967H18.8078V9.00635H9.24414V28.0013H18.8078V19.9072H25.2393Z"
        fill="#003087"
      />
      <mask
        id="mask1_33426_2818"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="90"
        height="37"
      >
        <path d="M90 0H0V37H90V0Z" fill="white" />
      </mask>
      <g mask="url(#mask1_33426_2818)">
        <path
          d="M63.8912 26.2995V10.7119C67.3726 10.7119 70.1034 10.0779 70.1034 18.5242C70.1034 26.9706 67.8296 26.2995 63.8912 26.2995ZM70.0663 9.00635H54.4204V28.0755H70.0663C75.5652 28.0755 80.5105 23.945 80.5216 18.5354C80.5291 13.1554 75.5652 9.00635 70.0663 9.00635Z"
          fill="#003087"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_33426_2818">
        <rect width="90" height="37" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
